<template>
  <div style="width: 100%; height: 100%; pointer-events: auto">
    <el-row>
      <el-col :span="11">
        <el-input v-model="raw" type="textarea" :rows="40"></el-input>
      </el-col>
      <el-col :span="2">
        <el-button @click="go1">GO 1</el-button>
        <el-button @click="go2">GO 2</el-button>
        <el-button @click="go3">GO 3</el-button>
      </el-col>
      <el-col :span="11">
        <el-input v-model="result" type="textarea" :rows="40"></el-input>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import AppMap from '@/components/AppMap.js'
export default {
  name: 'CoordinateConvertor',
  components: {},
  data() {
    return {
      raw: null,
      result: null,
      points: null,
      cursor: null,
      convertor: null,
    }
  },
  mounted() {
    console.log('【↑↑↑】', this.$options.name)
    this.convertor = new BMapGL.Convertor()
  },
  beforeDestroy() {
    console.log('【↓↓↓】', this.$options.name)
  },
  methods: {
    /**
     * 转换geojson中coordinates的
     */
    convert() {
      const { points, cursor, convertor } = this
      if (points === null || cursor === null || cursor === points.length) {
        return
      }
      const pair = points[cursor]
      convertor.translate(
        [new BMapGL.Point(pair[0], pair[1])],
        COORDINATES_WGS84,
        COORDINATES_BD09,
        (data) => {
          const { lng, lat } = data.points[0]
          this.result.push(`[${lng}, ${lat}]`)
          // const p = data.points[0]
          // console.log(p.lng, p.lat)
          this.cursor++
          this.convert()
        }
      )
    },
    convert2() {
      const { points, cursor, convertor } = this
      if (points === null || cursor === null || cursor === points.length) {
        return
      }
      const item = points[cursor]
      convertor.translate(
        [new BMapGL.Point(item.lng, item.lat)],
        COORDINATES_WGS84,
        COORDINATES_BD09,
        (data) => {
          const { lng, lat } = data.points[0]
          this.result.push(`{"lng":${lng}, "lat":${lat}}`)
          this.cursor++
          this.convert2()
        }
      )
    },
    convert3() {
      const { points, cursor, convertor } = this
      if (points === null || cursor === null || cursor === points.length) {
        this.result = JSON.stringify(points)
        return
      }
      const item = points[cursor]
      convertor.translate(
        [new BMapGL.Point(item.center[0], item.center[1])],
        COORDINATES_WGS84,
        COORDINATES_BD09,
        (data) => {
          const { lng, lat } = data.points[0]
          item.center[0] = lng
          item.center[1] = lat
          this.cursor++
          this.convert3()
        }
      )
    },

    go1() {
      this.points = JSON.parse(this.raw)
      this.cursor = 0
      this.result = []
      this.convert()
    },
    go2() {
      this.points = JSON.parse(this.raw)
      this.cursor = 0
      this.result = []
      this.convert2()
    },
    go3() {
      this.points = JSON.parse(this.raw)
      this.cursor = 0
      this.result = null
      this.convert3()
    },
  },
}
</script>


<style scoped >
</style>

<style>
textarea {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// src/components/CoordinateConvertor.vue